import { useTranslation } from 'react-i18next';
import { MKT } from '../marketing.design';

export default function MktLoading({ text }) {
    const { t } = useTranslation('marketing');
    const displayText = text ?? t('common.loading');

    return (
        <div className={MKT.loading.box}>
            <div className={MKT.loading.spinner} />
            {displayText && <p className={MKT.loading.text}>{displayText}</p>}
        </div>
    );
}
